// extracted by mini-css-extract-plugin
module.exports = {"body":"_105329b597--body--_UhTB","body--phone":"_105329b597--body--phone--eKcjl","body--modal":"_105329b597--body--modal--yRrry"};